import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "text-12px font-regular font-montserrat text-gray-lp-600" }
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = {
  key: 0,
  class: "ml-2 text-px text-14px text-gray-lp-300 font-normal"
}
const _hoisted_4 = {
  key: 1,
  class: "ml-2 text-px text-14px text-gray-lp-300 font-normal"
}
const _hoisted_5 = {
  key: 2,
  class: "inline"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Checkbox = _resolveComponent("Checkbox")!

  return (_openBlock(), _createBlock("div", {
    class: ["px-3 grid gap-x-3 relative", `${_ctx.isShowCODAmountField ? 'grid-cols-3' : 'grid-cols-2'}`]
  }, [
    _createVNode(_component_DataWrapper, {
      label: _ctx.$t('bookingV3.shipment.itemPrice.label'),
      fontSize: 12
    }, {
      default: _withCtx(() => [
        _createVNode(_component_lp_input, {
          modelValue: _ctx.formData.estimationPrice,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.estimationPrice = $event)),
          prefix: _ctx.prefixCurrency,
          format: _ctx.formatEstimationPrice,
          onKeydown: _cache[2] || (_cache[2] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"])),
          placeholder: _ctx.$t('bookingV3.shipment.itemPrice.placeholder'),
          onChange: _ctx.inputEstimationPrice,
          errorIcon: false,
          error: _ctx.errorMandatory || _ctx.isErrorIndex,
          errorCaption: _ctx.errMsgPrice,
          prefixBackground: "bg-white",
          prefixPadding: "px-4",
          onFocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.errorIndex = _ctx.goodsPriceIndex)),
          disabled: _ctx.getRulePriceDisabled,
          disabledBackground: _ctx.getRulePriceDisabled,
          marginVertical: _ctx.errorMandatory || _ctx.isErrorIndex ? 'my-1' : 'mt-1',
          sizeProportional: "py-1.5",
          "data-testid": "booking-create-input-goods-value"
        }, null, 8, ["modelValue", "prefix", "format", "placeholder", "onChange", "error", "errorCaption", "disabled", "disabledBackground", "marginVertical"])
      ]),
      _: 1
    }, 8, ["label"]),
    (_ctx.isShowCODAmountField)
      ? (_openBlock(), _createBlock(_component_DataWrapper, {
          key: 0,
          label: _ctx.$t('bookingV3.shipment.codAmount.label'),
          optional: true,
          fontSize: 12
        }, {
          default: _withCtx(() => [
            _createVNode(_component_lp_input, {
              modelValue: _ctx.formData.codAmount,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.codAmount = $event)),
              prefix: _ctx.prefixCurrency,
              format: _ctx.formatEstimationPrice,
              onKeydown: _cache[5] || (_cache[5] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"])),
              placeholder: _ctx.$t('bookingV3.shipment.codAmount.placeholder'),
              prefixBackground: "bg-white",
              prefixPadding: "px-4",
              disabled: _ctx.getRuleCodDisabled,
              disableBackground: _ctx.getRuleCodDisabled,
              marginVertical: "mt-1",
              sizeProportional: "py-1.5",
              "data-testid": "booking-create-input-cod-amount"
            }, null, 8, ["modelValue", "prefix", "format", "placeholder", "disabled", "disableBackground"]),
            _createVNode("p", _hoisted_1, _toDisplayString(_ctx.$t("bookingV3.shipment.codAmount.info")), 1)
          ]),
          _: 1
        }, 8, ["label"]))
      : _createCommentVNode("", true),
    (_ctx.isForceShowInsurance)
      ? (_openBlock(), _createBlock(_component_DataWrapper, {
          key: 1,
          fontSize: 12,
          label: _ctx.$t('bookingV3.shipment.insurance.label'),
          tooltipTitle: _ctx.$t('bookingV3.shipment.insurance.tooltip.title'),
          tooltipDescription: 
        _ctx.accountIsNonForeign
          ? _ctx.$t('bookingV3.shipment.insurance.tooltip.message')
          : _ctx.$t('bookingV3.shipment.insurance.tooltip.message', {
              startFrom: _ctx.formatPriceTooltip(
                _ctx.insuranceBasic.insuranceBasicStartFrom
              ),
              cost: _ctx.insuranceBasic.insuranceFee,
              minFee: _ctx.formatPriceTooltip(_ctx.insuranceBasic.minInsuranceFee)
            })
      ,
          isDarkMode: ""
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_2, [
              _createVNode("div", { class: `mt-2.5 flex items-start` }, [
                _createVNode(_component_Checkbox, {
                  "data-testid": "booking-insurance-checkbox-basic",
                  id: "checkbox_proteksi_create_booking",
                  binary: true,
                  modelValue: _ctx.isInsuranceBasic,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.isInsuranceBasic = $event)),
                  disabled: 
              _ctx.disabledInsuranceBasic ||
                _ctx.getRuleInsuranceDisabled ||
                (!_ctx.isCoveredInsuranceBasic && _ctx.isNonCod && !_ctx.isBookingTypeShipment)
            ,
                  disabledBackground: 
              _ctx.disabledInsuranceBasic ||
                _ctx.getRuleInsuranceDisabled ||
                (!_ctx.isCoveredInsuranceBasic && _ctx.isNonCod && !_ctx.isBookingTypeShipment)
            
                }, null, 8, ["modelValue", "disabled", "disabledBackground"]),
                (_ctx.shippingIsProtected)
                  ? (_openBlock(), _createBlock("label", _hoisted_3, _toDisplayString(_ctx.$t("bookingV3.shipment.insurance.protected")), 1))
                  : (_openBlock(), _createBlock("label", _hoisted_4, _toDisplayString(_ctx.$t("bookingV3.shipment.insurance.protection")), 1)),
                (!_ctx.shippingIsProtected)
                  ? (_openBlock(), _createBlock("div", _hoisted_5, [
                      _withDirectives(_createVNode("label", { class: "font-bold m-1 text-px text-14px text-black-lp-100 " }, _toDisplayString(`(${_ctx.$t(
                  "bookingV3.shipment.insurance.discount"
                )} ${_ctx.accountIsForeign ? 'RM' : 'Rp'}${_ctx.insuranceCommissionPos})`), 513), [
                        [_vShow, _ctx.isFormBookManual && _ctx.getAccount.accountType === 'partner']
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 2)
            ])
          ]),
          _: 1
        }, 8, ["label", "tooltipTitle", "tooltipDescription"]))
      : _createCommentVNode("", true)
  ], 2))
}